

<script>
/* eslint-disable no-empty */
/* eslint-disable no-undef */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Swal from "sweetalert2";

import DatePicker from "vue2-datepicker";
import Switches from "vue-switches";
import Multiselect from "vue-multiselect";
import HotelDatePicker from "vue-hotel-datepicker";
import NumberInputSpinner from "vue-number-input-spinner";
import {
  urlMethods,
} from "@/state/helpers";

export default {
    page: {
        title: "Đơn thu hồi COD",
        meta: [
        {
            name: "description",
            content: appConfig.description,
        },
        ],
    },
    components: {
        Layout,
        HotelDatePicker,
        DatePicker,
        Switches,
        Multiselect,
        NumberInputSpinner
    },
    data() {
        return {
            isLoading: false,
            breadcrumbData: [
                {text: "Trang chủ", to: { name: 'default' }},
                {text: "Danh sách đơn thu hồi COD",to: { name: 'hbcod' }},
                {text: "Chi tiết đơn",active: true}
            ],
            order: {
                id: 0
            },
            logs: [],
        };
    },
    computed: {
        currentUser() {
            let user = localStorage.getItem('currentUser') || false;
            return user ? JSON.parse(user) : false;
        },
        order_name(){
            if(!this.order || !this.order.name) return '';
            return this.order.name;
        },
        grossSale(){
        let total = 0;
        for(const item of this.order.products){
            total += parseFloat(item.price_total);
        }
        total = Math.round(total);
        return total.toLocaleString();
        },
    },
  methods: {
    ...urlMethods,
    async getOrder(){
        this.order.id = this.$route.params.id;
        try {
            let res = await this.getUrl('hbcod/'+this.order.id);
            if(typeof res.data == 'undefined' || !res.data || res.data == null || typeof res.data.id == 'undefined'){
                throw 'Không thể lấy thông tin đơn hàng';
            }
            this.order = res.data;
        } catch (error) {
            Swal.fire({icon: 'error',title: 'Lỗi...',text: error});
        }
    },
    async getOrderLogs(){
        try {
            let res = await this.getUrl('hbcod/logs/'+this.$route.params.id);
            if(typeof res.data == 'undefined' || !res.data || res.data == null){
                throw 'Không thể lấy thông tin lịch sử đơn hàng';
            }
            this.logs = res.data;
            console.log(this.logs);
        } catch (error) {
            console.log(error);
        }
    },
    discount_text(discount){
        if(!discount|| discount <= 0) return '0%';
        return discount + '%';
    },
  },
  mounted() {
    this.getOrder();
    this.getOrderLogs();
  },
};
</script>

<template>
  <Layout>
        <div class="page-header mb-2">
            <div class="page-title">
              <h4 class="mb-0 font-size-18">
                <span v-html="order_name"></span>
                <a
                  v-if="order.id"
                  :href="`https://one.tga.com.vn/so/returns/detail/${order.id}`"
                  target="_blank"
                  rel="noopener noreferrer"
                  style="margin-left: 6px; color: #adb5bd; vertical-align: middle;"
                ><i class="bx bx-link-external font-size-16"></i></a>
              </h4>
            </div>
            <b-breadcrumb :items="breadcrumbData" class="m-0 p-0"></b-breadcrumb>
        </div>
    <div class="card">
    <div class="card-body p-0">
        <div class="row" v-if="typeof order.name != 'undefined'">
            <div class="col-md-6  mb-0">
                <div class="card p-0  mb-0">
                    <div class="card-body p-2  mb-0">
                        <div class="table-responsive">
                        <table class="table table-striped mb-0" style="background: white;">
                            <tbody>
                                <tr>
                                    <th width="100px">Phiếu bán hàng</th>
                                    <td scope="row">{{order.so_name}}</td>
                                </tr>
                                <tr>
                                    <th>Khách hàng</th>
                                    <td scope="row">{{order.customer_name}} - {{order.customer_phone}}</td>
                                </tr>
                                <tr>
                                    <th>NV bán hàng</th>
                                    <td scope="row">{{order.saler}}</td>
                                </tr>
                                <tr>
                                    <th>NV thu hồi</th>
                                    <td scope="row">{{order.username}}</td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6  mb-0">
                <div class="card p-0 mb-0">
                    <div class="card-body p-2  mb-0">
                        <div class="table-responsive">
                        <table class="table table-striped mb-0" style="background: white;">
                            <tbody>
                                <tr>
                                    <th width="100px">Ngày thu hồi</th>
                                    <td scope="row">{{order.created_at}}</td>
                                </tr>
                                <tr>
                                    <th>Kho nhận</th>
                                    <td scope="row">{{order.warehouse_name}}</td>
                                </tr>
                                <tr>
                                    <th>Lý do thu hồi</th>
                                    <td scope="row">{{order.reason}}</td>
                                </tr>
                                <tr>
                                    <th>Trạng thái</th>
                                    <td scope="row"><span :class="'badge font-size-12 bg-'+order.status_class">{{ order.status_name }}</span></td>
                                </tr>
                                <tr v-if="typeof order.note != 'undefined' && order.note != ''">
                                    <th>Ghi chú</th>
                                    <td scope="row" v-html="order.note"></td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
        <div class="card" style="margin: 15px 0px 0px; padding: 0px 10px;" v-if="typeof order.products != 'undefined' && order.products.length > 0">
        <div class="table-responsive" style="padding: 0px">
            <table class="table table-striped mb-0">
                <thead>
                <tr>
                    <th>Serial</th>
                    <th>Sản phẩm</th>
                    <!-- <th>Số lượng</th> -->
                    <th class="text-right">Đơn giá</th>
                    <th class="text-right">Giảm giá (%)</th>
                    <th class="text-right">Tổng tiền</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in order.products" :key="index">
                    <td>{{ item.serial }}</td>
                    <td>{{ item.name == 'GIAM THANH VIEN' ? 'Giảm thành viên' : item.name }}</td>
                    <!-- <td>1</td> -->
                    <td class="text-right">{{parseFloat(item.price_unit).toLocaleString()}}</td>
                    <td class="text-right">{{parseFloat(item.discount).toLocaleString()}}</td>
                    <td class="text-right">{{parseFloat(item.price_total).toLocaleString()}}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div>
        <div class="pull-right" style="max-width: 300px;">
                <table class="table mb-0">
                    <tbody>
                        <tr style="font-size: 1.3em; font-weight: bold;">
                            <td>THÀNH TIỀN: </td><th>{{ grossSale }} <sup>₫</sup></th>
                        </tr>
                    </tbody>
                </table>
            </div></div>
        </div>
        <div class="card m-0" v-if="logs.length > 0">
          <div class="card-body pt-0 pb-0">
            <h4 class="card-title mb-3">Lịch sử</h4>
            <div class>
              <ul class="verti-timeline list-unstyled">
                <li class="event-list"  v-for="(item,index) in logs" :key="index">
                  <div class="event-timeline-dot"><i class="bx bx-time-five"></i></div>
                  <div>
                    <p style="margin-bottom: 5px;">Ghi chú bởi <strong>{{item.username}}</strong> - <small>{{item.time}}</small></p>
                    <p class="text-muted" v-html="item.content"></p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div></div>
    <div :class="isLoading ? 'flex-middle-full' : 'hidden'"><i class="fas fa-spinner fa-spin font-size-34"></i></div>
  </Layout>
</template>
